import e from "@emotion/styled/base";
function c() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const a = /* @__PURE__ */ e("div", process.env.NODE_ENV === "production" ? {
  target: "e10fazf30"
} : {
  target: "e10fazf30",
  label: "FlexDiv"
})(process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "82a6rk",
  styles: "flex:1/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvVGFibGUvc3ViQ29tcG9uZW50cy9TZWxlY3RCYXIvU2VsZWN0QmFyLnN0eWxlZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFaUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvcGFydG9vLXVpL3BhcnRvby11aS9wYWNrYWdlcy91aS9zcmMvY29tcG9uZW50cy9UYWJsZS9zdWJDb21wb25lbnRzL1NlbGVjdEJhci9TZWxlY3RCYXIuc3R5bGVkLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5leHBvcnQgY29uc3QgRmxleERpdiA9IHN0eWxlZC5kaXZgXG4gIGZsZXg6IDE7XG5gO1xuIl19 */",
  toString: c
});
export {
  a as FlexDiv
};
